import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { RedirectWithSearchParams } from '@carvana/purchase-helpers';
import { Error } from '@carvana/purchase-styles';
import DashboardRoute from 'Components/dashboard/routes';
import VehicleRoute from 'Components/vehicle/routes';
import PurchaseRoute from 'Components/restricted/routes';
import AccountLoggedInRoute from 'Helpers/routes/account-logged-in-route';
import Dashboard from 'Components/dashboard/components/dashboard';

const ExampleComponent = lazy(() =>
  import(/* webpackChunkName: "carvana-purchase-example" */ './routes/example')
);

const RouteNotFound = () => <RedirectWithSearchParams to="/dashboard" />;

const Routes = props => {
  const {
    navigationConfiguration: { navItems }
  } = props;

  return (
    <Switch>
      <Route path="/example">
        <ExampleComponent />
      </Route>

      <Route path="/account">
        <AccountLoggedInRoute />
      </Route>

      <Route path="/error">
        <Error />
      </Route>

      <Route path="/error-price">
        <Error
          routeToSearch
          message="We are unable to start a purchase with this vehicle. If you would like to continue, please contact us at (800) 333-4554."
        />
      </Route>

      <Route path="/dashboard">
        <DashboardRoute />
      </Route>

      <Route path="/vehicle">
        <VehicleRoute />
      </Route>

      <Route path="/restricted">
        <PurchaseRoute />
      </Route>

      {navItems
        ?.filter(config => !config.isDisabled)
        ?.map(config => (
          <Route key={config.id} path={config.route}>
            {() => (
              <Dashboard>
                <config.component {...props} />
              </Dashboard>
            )}
          </Route>
        ))}

      <RouteNotFound {...props} />
    </Switch>
  );
};

Routes.propTypes = {
  location: PropTypes.shape({}).isRequired,
  navigationConfiguration: PropTypes.shape({})
};

Routes.defaultProps = {
  navigationConfiguration: {
    navItems: []
  }
};

export default Routes;
